module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('header', {
    staticClass: "bar bar-nav"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("选择支付配送方式")]), _vm._v(" "), _c('router-link', {
    staticClass: "button button-link button-nav pull-left",
    attrs: {
      "to": {
        name: 'orderContent'
      }
    }
  }, [_c('span', {
    staticClass: "icon icon-left",
    staticStyle: {
      "font-size": "18px"
    }
  }, [_vm._v("返回")])])], 1), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "checkout-title"
  }, [_c('span', [_vm._v("结算方式")])]), _vm._v(" "), _c('div', {
    staticClass: "list-block media-list",
    staticStyle: {
      "margin-top": "1px",
      "margin-bottom": "2px"
    }
  }, [_c('ul', [_c('li', [_c('div', {
    staticClass: "item-inner",
    staticStyle: {
      "left": "10px"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "item-title button col-50",
    attrs: {
      "data-payType": "1"
    }
  }, [_vm._v("预支付")]), _vm._v(" "), _c('div', {
    staticClass: "item-title-after button col-50",
    attrs: {
      "data-payType": "2"
    }
  }, [_vm._v("后支付")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "item-title button col-50",
    attrs: {
      "data-payType": "3"
    }
  }, [_vm._v("先货后款")]), _vm._v(" "), _c('div', {
    staticClass: "item-title-after button col-50",
    attrs: {
      "data-payType": "4"
    }
  }, [_vm._v("在线支付")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "checkout-title"
  }, [_c('span', [_vm._v("配送方式")])]), _vm._v(" "), _c('div', {
    staticClass: "list-block media-list",
    staticStyle: {
      "margin-top": "2px",
      "margin-bottom": "2px"
    }
  }, [_c('ul', [_c('li', [_c('div', {
    staticClass: "item-inner",
    staticStyle: {
      "left": "10px"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "item-title button col-50"
  }, [_vm._v("顺丰快递")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-465a70d3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./script/loaders/emktVueLoader.js!./src/views/Order/Detail/PayDetail.vue
// module id = 1620
// module chunks = 8